import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { useSellerAuth } from "@/context/SellerAuthContext";
import { NotificationBell } from "@/components/NotificationBell";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Store, LogOut, Package, ShoppingCart, User } from "lucide-react";

const LINKS = [
  { to: "/seller/dashboard", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/seller/dashboard/products", label: "Products", icon: Package },
  { to: "/seller/dashboard/orders", label: "Orders", icon: ShoppingCart },
  { to: "/seller/dashboard/profile", label: "Profile", icon: User },
];

export default function SellerLayout() {
  const { seller, logout } = useSellerAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    navigate("/seller/login");
  };

  return (
    <div className="flex min-h-screen bg-cream">
      <aside className="hidden w-64 flex-col border-r border-border bg-white lg:flex">
        <Link to="/seller/dashboard" className="flex items-center gap-2 px-6 py-5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand text-ink"><Store className="h-5 w-5" /></span>
          <div>
            <p className="font-heading text-lg font-bold text-ink">NICEE Seller</p>
            <p className="text-xs text-ink-muted">{seller?.shop_name}</p>
          </div>
        </Link>
        <nav className="flex-1 space-y-1 px-3">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`seller-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-brand text-ink" : "text-ink-soft hover:bg-cream-alt"}`}>
              <l.icon className="h-4 w-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-border p-4">
          <p className="px-2 text-xs text-ink-muted">Signed in as</p>
          <p className="px-2 text-sm font-semibold text-ink">{seller?.owner_name}</p>
          <Button variant="ghost" onClick={doLogout} className="mt-2 w-full justify-start rounded-xl text-ink-soft hover:text-destructive" data-testid="seller-logout">
            <LogOut className="mr-2 h-4 w-4" /> Log out
          </Button>
        </div>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex items-center justify-between border-b border-border bg-white px-4 py-3 sm:px-6 lg:px-8">
          <span className="font-heading font-bold text-ink lg:hidden">NICEE Seller</span>
          <span className="hidden lg:block" />
          <div className="flex items-center gap-3">
            <NotificationBell />
            <Button variant="ghost" size="sm" onClick={doLogout} className="lg:hidden" data-testid="seller-logout-mobile"><LogOut className="h-4 w-4" /></Button>
          </div>
        </header>
        <main className="flex-1 overflow-x-hidden p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
